package dev.terrakok.mapitan.domain.utils

import kotlin.concurrent.atomics.AtomicInt
import kotlin.concurrent.atomics.ExperimentalAtomicApi
import kotlin.concurrent.atomics.fetchAndIncrement
import kotlin.uuid.Uuid

private const val SESSION_LENGTH = 5
private const val ALPHABET = "abcdefghijklmnopqrstuvwxyz"
private val session = List(SESSION_LENGTH) { ALPHABET.random() }.joinToString("")

@OptIn(ExperimentalAtomicApi::class)
private val counter = AtomicInt(0)

@OptIn(ExperimentalAtomicApi::class)
fun generateId(): String = session + counter.fetchAndIncrement()